import { useEffect, useState } from "react";
import { apiRequest } from "../../shared/api/client";
import { dailyCashResponseSchema } from "../../../shared/account-finance/daily-cash-contract";
import type { DailyCash } from "../../../shared/account-finance/daily-cash-contract";

export function useDailyCashWorkspace(date: string, version: number, enabled: boolean, refresh = false) {
  const [report, setReport] = useState<(DailyCash & { origin: "saved" | "mikro" }) | null>(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  useEffect(() => {
    const controller = new AbortController();
    setReport(null); setError(null);
    if (!enabled) { setLoading(false); return () => controller.abort(); }
    setLoading(true);
    void apiRequest<unknown>(`/api/account-finance/cash?date=${date}&refresh=${refresh ? "1" : "0"}`, {
      signal: AbortSignal.any([controller.signal, AbortSignal.timeout(15_000)]),
    }).then((raw) => { if (!controller.signal.aborted) setReport(dailyCashResponseSchema.parse(raw)); })
      .catch((failure: unknown) => { if (!controller.signal.aborted) setError(failure instanceof Error ? failure.message : "Nakit raporu alınamadı."); })
      .finally(() => { if (!controller.signal.aborted) setLoading(false); });
    return () => controller.abort();
  }, [date, version, enabled, refresh]);
  return { report, loading, error };
}
